import { PropertyFacilities } from '@ha/api-v2/types/inventory/Property';

export function normalizePropertyFacilities(
  facilities: Partial<Record<PropertyFacilities, boolean>>,
): PropertyFacilities[] {
  return (Object.keys(facilities) as PropertyFacilities[]).filter(
    facility => facilities[facility] === true,
  );
}
